<template>
  <div class="faq-area ptb-100">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="faq-content">
            <span class="top-title">الأسئلة الشائعة</span>
            <h2>استفساراتكم حول خدمتنا</h2>
          </div>

          <div class="accordion style-two">
            <div
              class="accordion-item"
              v-for="(item, index) in accordionItems"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button pt-0"
                  type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)"
                >
                  {{ item.question }}
                </button>
              </h2>
              <div
                class="accordion-collapse collapse show"
                v-show="activeIndex === index"
              >
                <div class="accordion-body">
                  <p>{{ item.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="faq-img">
            <img src="@/assets/images/faq-2.png" alt="faq" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FAQ",
  setup() {
    const activeIndex = ref<number>(0);

    const accordionItems = [
      {
        question: "ما هي الأجهزة المدعومة للتشغيل؟",
        answer:
          "خدمتنا متوافقة مع جميع أجهزة التلفاز الذكية (Smart TV)، أجهزة Android، Apple TV، وأجهزة الكمبيوتر. لا حاجة لخبرة تقنية؛ بمجرد تحميل التطبيق، ستكون جاهزاً للاستمتاع بالمحتوى الأوروبي والألماني المفضل لديك.",
      },
      {
        question: "كيف أحصل على الدعم الفني؟",
        answer:
          "فريقنا التقني متاح على مدار الساعة لدعم عملائنا في ألمانيا وأوروبا. يمكنك التواصل معنا عبر الواتساب أو البريد الإلكتروني لأي استفسار تقني، وسنقوم بمساعدتك فوراً لضمان تجربة بث مستقرة.",
      },
      {
        question: "كم يستغرق تفعيل الاشتراك؟",
        answer:
          "بعد إتمام عملية الدفع، يتم إرسال بيانات اشتراكك فوراً إلى بريدك الإلكتروني أو الواتساب. العملية سريعة جداً ومصممة لتناسب وتيرة الحياة في أوروبا، حيث يمكنك البدء بالمشاهدة في غضون دقائق.",
      },
      {
        question: "ما هي سياسة الاسترجاع؟",
        answer:
          "نحن نضمن جودة خدماتنا. في حال واجهت أي مشكلة تقنية لم نستطع حلها، نقدم سياسة استرجاع مرنة تضمن حقوقك، مما يجعل تجربتك معنا آمنة وموثوقة.",
      },
      {
        question: "هل الخدمة تعمل بكفاءة في ألمانيا وأوروبا؟",
        answer:
          "نعم، خوادمنا مصممة خصيصاً لتوفير بث عالي الجودة (4K/HD) ومستقر في ألمانيا وكافة دول أوروبا. نعتمد تقنيات متطورة لتجنب أي تقطيع، لضمان استمتاعك بالقنوات المفضلة لديك دون انقطاع.",
      },
    ];

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>